import { wpApiInstance} from '../api/wp-api';
import { awsApiInstance } from '../api/aws-api';

import { IUserWpUpdate, IUserAwsUpdate, IPostNewUser } from '../models/user.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Updates the user on the WordPress side.
 * 
 * @param {IUserWpUpdate} user the form data
 */
const wpUpdateUserIndividual = async (user: IUserWpUpdate): Promise<IPostNewUser> => {
  try {
    const modelData = {
      updateUserID: user.updateUserID,
      updateUserName: user.updateUserName,
      updateUserFirstName: user.updateUserFirstName,
      updateUserLastName: user.updateUserLastName,
      updateUserEmail: user.updateUserEmail,
      updateUserStatus: user.updateUserStatus,
      updateUserRole: user.updateUserRole
    };

    const { data } = await wpApiInstance.put(`/admin/users/${user.updateUserID}`, { json: modelData });

    return data;
  } catch (error) {
    handleRouteError(error, 'Error updating user');
    throw(error);
  }
}

/**
 * Updated an individual user
 * 
 * @param {IUserAwsUpdate} user the form data
 * 
 * @returns {IPostNewUser} the api response | error
 */
const awsUpdateUserIndividual = async (user: IUserAwsUpdate): Promise<IPostNewUser> => {
  try {
    const modelData = {
      updateUserName: user.updateWpName,
      updateAccessLevel: user.updateAccessLevel,
      updateAccessType: user.updateAccessType,
      updateIdArray: user.updateIdArray,
      adminId: user.adminId
    };

    const { data } = await awsApiInstance.put(`/user/${user.updateWpId}`, modelData );

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error updating user');
    throw(error);
  }
}

export { wpUpdateUserIndividual, awsUpdateUserIndividual };